import { z } from 'zod'

export const ClientInfoScheme = z.object({
    gameBuild: z.string(),
    preloaderBuild: z.string(),
    buildType: z.string(),
    deploy: z.number(),
    assets: z.number(),
    preloaderStartTime: z.number(),
    sessionTime: z.number(),
    timeToShowGame: z.number(),
})

export type ClientInfo = z.infer<typeof ClientInfoScheme>

export const PerformanceStatsScheme = z.object({
    maxVram: z.number(),
    averageVram: z.number(),
    instantVram: z.number(),
    averageFps: z.number(),
    instantFps: z.number(),
    averageImageDecodeSpeed: z.number(),
    minImageDecodeSpeed: z.number(),
})

export type PerformanceStats = z.infer<typeof PerformanceStatsScheme>

export const NetworkStatsScheme = z.object({
    averageLatency: z.number(),
    instantLatency: z.number(),
    downloadSuccessRate: z.number(),
    averageRetriesPerSuccess: z.number(),
    averageDownloadSpeed: z.number(),
    minDownloadSpeed: z.number(),
})

export type NetworkStats = z.infer<typeof NetworkStatsScheme>

export type GameClient = {
    getClientLog: () => string
    getClientInfo: () => ClientInfo
    getPerformanceStats: () => PerformanceStats
    getNetworkStats: () => NetworkStats
}

export type GameConnectAttempt = { phase: 'initial' | 'reconnect' }
